/*
 * @Author: zhongtao
 * @LastEditors: zhongtao
 */
import pageClass from '@/unit/pageClass'

// class searchFrom extends pageClass
export default pageClass
